import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
//import MaintenanceView from '../views/MaintenanceView.vue'

const routes = [

  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/historie-czs',
    name: 'historie',
    component: () => import(/* webpackChunkName: "historie" */ '../views/about/HistorieView.vue')
  },
  {
    path: '/stanovy-czs',
    name: 'stanovy',
    component: () => import(/* webpackChunkName: "stanovy" */ '../views/about/StanovyView.vue')
  },
  {
    path: '/vybor-czs',
    name: 'vybor',
    component: () => import(/* webpackChunkName: "vybor" */ '../views/about/VyborView.vue')
  },
  {
    path: '/revizni-komise',
    name: 'komise',
    component: () => import(/* webpackChunkName: "komise" */ '../views/about/TestView.vue')
  },
  {
    path: '/clenove/informace',
    name: 'clenove',
    component: () => import(/* webpackChunkName: "knihovna" */ '../views/members/ProClenyView.vue')
  },
  {
    path: '/clenove/knihovna',
    name: 'knihovna',
    component: () => import(/* webpackChunkName: "knihovna" */ '../views/members/KnihovnaView.vue')
  },
  {
    path: '/acta-societatis-zoologicae-bohemicae',
    name: 'acta',
    component: () => import(/* webpackChunkName: "acta" */ '../views/ActaSocietatesView.vue')
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import(/* webpackChunkName: "privacy-policy" */ '../views/PrivacyPolicyView.vue')
  },
  {
    path: '/odborna-stanoviska-czs',
    name: 'odborna-stanoviska',
    component: () => import(/* webpackChunkName: "odborna-stanoviska" */ '../views/publication/OdbornaStanoviskaView.vue')
  },
  {
    path: '/informacni-zpravodaj',
    name: 'informacni-zpravodaj',
    component: () => import(/* webpackChunkName: "odborna-stanoviska" */ '../views/publication/ZpravodajView.vue')
  },
  {
    path: '/account',
    name: 'account',
    component: () => import(/* webpackChunkName: "account" */ '../views/AccountView.vue')
  },
  {
    path: '/members',
    name: 'members',
    component: () => import(/* webpackChunkName: "account" */ '../views/MembersView.vue')
  },
  {
    path: '/registrace',
    name: 'registrace',
    component: () => import(/* webpackChunkName: "registration" */ '../views/RegistraceView.vue')
  },
/*   {
    path: '/dev',
    name: 'development',
    component: () => import( '../views/DevView.vue')
  }, */
  {
    path: '/admin',
    name: 'adminHome',
    component: () => import(/* webpackChunkName: "dev" */ '../views/admin/AdminHome.vue')
  },
  {
    path: '/admin/members',
    name: 'adminMembers',
    component: () => import(/* webpackChunkName: "dev" */ '../views/admin/AdminMembers.vue')
  },
  {
    path: '/events/:id',
    name: 'eventy',
    component: () => import(/* webpackChunkName: "events" */ '../views/EventsView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
